import styled from '@emotion/styled';
import { DebouncedInputField } from '../../Input/DebouncedInputField/component';
import { OL_COLOUR_BLACK_55 } from '../../Style/colours';

export const SelectorWrapper = styled('div')({
  position: 'relative',
});

export const SelectorDropdown = styled('div')({
  display: 'flex',
  padding: '12px 8px',
  border: '2px solid #a0a0a0',
  borderRadius: 4,
  maxWidth: '530px',
  justifyContent: 'space-between',
  cursor: 'pointer', // TODO: don't rely on this
  alignItems: 'center',
  minHeight: 48,
});

export const SelectorDropdownFlexWrap = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
});

export const SelectorModal = styled('div')({
  position: 'absolute',
  zIndex: 10,
  top: 0,
  display: 'flex',
  flexDirection: 'column',
  border: '1px solid #606060',
  borderRadius: 4,
  width: '100%',
  maxWidth: '530px',
  maxHeight: '312px',
  background: 'white',
});

export const SelectorSearchInput = styled(DebouncedInputField)({
  margin: '8px 14px 4px',

  '.ol-text-field-icon': {
    width: 20,
  },

  '.ol-text-field-text': {
    padding: '2px 8px',
    transition: 'all 0.3s ease',

    '&[type="text"]': {
      lineHeight: '24px',
      outline: 'none !important',
      border: 'none',
      borderBottom: '2px solid #d0d0d0',
    },

    '&:focus': {
      boxShadow: 'none',
      borderBottom: '2px solid #7a7a7a',
    },
  },
});

export const SelectorModalContainer = styled('div')({
  display: 'flex',
  flexShrink: 1,
  flexDirection: 'column',
  overflowY: 'auto',
});

export const SelectorItems = styled('div')({
  padding: '4px 8px',
});

export const SelectorModalFooter = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: 14,
});

export const SelectorModalFooterText = styled('div')({
  marginLeft: 8,
  color: OL_COLOUR_BLACK_55,
});
